import React from "react";
import { Box, Typography } from "@mui/material";
import { useState } from "react";
//import { ArrowOutward } from "@mui/icons-material";


export default function CardHoverCeci({ Image, Titolo, Descrizione, Desc02 }) {

  const [hover, setHover] = React.useState(false);
  
  return (
    <Box
      sx={{        
        position: "relative",
        width: "100%",
        height: "100%",
        borderRadius: "20px",
        overflow: "hidden",
        backgroundImage: `url('/assets/${Image}')`, // <-- sostituisci con il tuo path
        backgroundSize: "cover",
        backgroundPosition: "center",
        transition: "all 0.3s ease",
        cursor: "pointer",
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(82, 113, 128, 0.4)", // overlay blu-grigio trasparente
          transition: "background-color 0.3s ease",
        },
        "&:hover::before": {
          backgroundColor: "rgba(82, 113, 128, 0.6)",
        },
        "&:hover .description": {
          opacity: 1,
          transform: "translateY(0)",
        },
        "&:hover .sottolinare": {
          opacity: 1,
          transform: "translateY(0)",
          textDecoration: "underline"
        },
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {/* Titolo */}
      <Box
        sx={{
          position: "absolute",
          left: 0,
          //width: "100%",
          zIndex: 2,
          textAlign: "left",
          marginX: "60px",
          paddingY: "50px"
        }}
      >
        <div
          className="stile-card-titolo bianco sottolinare"
        >
          {Titolo}
        </div>
      </Box>

      {/* Descrizione visibile su hover */}
      <Box
        className="description"
        sx={{
          textAlign: "left",
          position: "absolute",
          bottom: 90,
          color: "#FFF",
          fontFamily: "'Barlow', sans-serif",
          fontSize: "1rem",
          opacity: 0,
          transform: "translateY(20px)",
          transition: "all 0.3s ease",
          zIndex: 2,
        }}
      >
        <div
          className="stile-card-sottotitolo bianco"
        >
          {Descrizione}
          <br/>
          {Desc02}
        </div>
      </Box>


      {/* Freccia in basso a destra */}
      { !hover &&
        <Box
          sx={{
            position: "absolute",
            right: "50px",
            bottom: "60px",
            zIndex: 2,
          }}
        >
          <svg width="25" height="25" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.9898 16.0199L0.857176 0.857177" stroke="white" stroke-width="1.71436" stroke-linecap="round"/>
            <path d="M15.9898 16.0195L0.857176 16.0195" stroke="white" stroke-width="1.71436" stroke-linecap="round"/>
            <path d="M15.9898 0.857178L15.9898 16.0199" stroke="white" stroke-width="1.71436" stroke-linecap="round"/>
          </svg>
        </Box>
      }
    </Box>
  );
}
